import React, { useEffect } from "react"
import { SiteHeader } from "../components/site-header"
import { ServicesHero } from "../components/services/hero-section"
import { CoreServices } from "../components/services/core-services"
import { KickstarterCallout } from "../components/services/kickstarter-callout"
import { TestimonialsSection } from "../components/shared/testimonials-section"
import { ServicesCTA } from "../components/services/services-cta"
import { useLocation } from "react-router-dom"
import { METADATA } from "../components/meta/metadata"

export default function ServicesPage() {
  const location = useLocation();

  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.services.title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.services.description);
  }, []);

  useEffect(() => {
    // Handle hash navigation
    if (location.hash) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    }
  }, [location]);

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <ServicesHero />
        <CoreServices />
        <KickstarterCallout />
        <TestimonialsSection className="bg-primary/5" />
        <ServicesCTA />
      </main>
    </div>
  )
}